define.alias("shared/components/shared/pre-boarding/survey/index", "settings/components/shared/pre-boarding/survey/index");